<template>
  <v-layout class="rounded rounded-md bg-leftarea">
    <div
      class="v-col-lg-2 v-col-xl-1 d-none d-lg-flex bg-leftarea pa-0"
      style="position: sticky; top: 100px; max-height: 80vh"
    >
      <Menu v-if="page?.menu" :menu="page.menu" :nav="true" bg-color="leftarea" color="white" class="w-100" />
    </div>
    <div class="v-col-sm-12 v-col-lg-10 v-col-xl-11 pa-0">
      <v-app-bar class="bg-appbar" order="4">
        <v-row no-gutters>
          <div class="v-col-4 d-lg-flex d-none d-lg-block">
            <ImageLogo />
          </div>
          <div class="v-col-2 d-lg-none d-flex justify-center" aria-label="menu">
            <v-btn id="menu-activator" icon="$menu" color="#FFFFFF" />
          </div>
          <v-col sm="6" class="d-flex justify-center d-lg-none">
            <ImageLogo />
          </v-col>
          <v-col lg="8" sm="4" class="pa-2">
            <Button
              :download-nick="nick"
              :software-title="soft"
              :text="page.downloadTitle"
              class="bg-yellowButton text-black mr-2 pa-2 float-right rounded-xl"
            />
          </v-col>
        </v-row>
      </v-app-bar>
      <v-menu activator="#menu-activator">
        <Menu v-if="page?.menu" :menu="page.menu" nav class="mt-4" />
      </v-menu>
      <v-main class="align-center justify-center bg-main mt-10" style="min-height: 300px">
        <aside v-if="page?.blocks?.AboveContent" class="mx-1">
          <Region :key="page.uri" region="AboveContent" :blocks="page.blocks.AboveContent" />
        </aside>

        <v-row v-if="page?.blocks?.RightSide" no-gutters>
          <v-col cols="12" md="9">
            <article class="rounded ma-2 pa-5">
              <Article :key="page.uri" class="ma-2 pa-3"></Article>

              <Button
                :download-nick="nick"
                :software-title="soft"
                :text="page.downloadTitle"
                class="d-block ma-auto pa-2 mt-2 text-uppercase font-weight-bold"
              />
            </article>
            <aside v-if="page?.blocks?.BelowContent">
              <Region :key="page.uri" region="BelowContent" :blocks="page.blocks.BelowContent" />
            </aside>
          </v-col>
          <v-col cols="12" md="3">
            <aside v-if="page?.blocks?.RightSide" class="ml-2 mr-2">
              <Region
                :key="page.uri"
                region="RightSide"
                :blocks="page.blocks.RightSide"
                class="blockDesign rightBlock"
                @noregion="page.hideRegion"
              />
            </aside>
          </v-col>
        </v-row>
        <template v-else>
          <article class="rounded ma-2 pa-5">
            <Article :key="page.uri" class="ma-2 pa-3"></Article>

            <Button
              :download-nick="nick"
              :software-title="soft"
              :text="page.downloadTitle"
              class="d-block ma-auto pa-2 mt-2 text-uppercase font-weight-bold"
            />
          </article>

          <aside v-if="page?.blocks?.BelowContent">
            <Region :key="page.uri" region="BelowContent" :blocks="page.blocks.BelowContent" />
          </aside>
        </template>

        <footer v-if="page?.blocks?.Footer" class="mt-5 pt-1">
          <Region :key="page.uri" region="Footer" :blocks="page.blocks.Footer" />
        </footer>
      </v-main>
    </div>
  </v-layout>
</template>
<script setup>
const page = inject("page");
const nick = ref(unref(page)?.rels?.downloadNick);
const soft = ref(unref(page)?.rels?.softwareTitle);

watchEffect(() => {
  nick.value = unref(page)?.rels?.downloadNick;
  soft.value = unref(page)?.rels?.softwareTitle;
});
</script>
